export default {"src":"/_next/static/media/arrow-up-green.a827f6ac.svg","height":11,"width":17,"blurWidth":0,"blurHeight":0};